import {alpha, decomposeColor} from "@mui/material/styles";

/** Calendar helpers shared by overview and demographic charts. */
export const CALENDAR_MONTH_KEYS = [
    "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
    "JUL", "AUG", "SEP", "OCT", "NOV", "DEC",
] as const;

export function currentCalendarMonthKey(now = new Date()): string {
    return CALENDAR_MONTH_KEYS[now.getMonth()];
}

export function currentMonthPoint(
    granularity: "DAY" | "WEEK" | "MONTH" | undefined,
    points: Array<{from: string}>,
    now = new Date(),
): Date | null {
    if (granularity !== "MONTH") return null;
    const point = points.find(({from}) => {
        const date = new Date(`${from}T00:00:00`);
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth();
    });
    return point ? new Date(`${point.from}T00:00:00`) : null;
}

export function currentMonthBarColor(color: string): string {
    const colorAlpha = decomposeColor(color).values[3] ?? 1;
    return alpha(color, colorAlpha * 0.45);
}
